<template>
    <v-dialog v-model="visible" persistent max-width="600px">
        <v-card light>
            <v-card-title class="justify-center">
                <v-spacer/>
                <span class="text-h5">
                    {{ form.id ? 'Edição' : 'Cadastro' }} de Meta
                </span>
                <v-spacer/>
            </v-card-title>
            <v-card-text>
                <v-row dense>
                    <v-col cols="12">
                        <v-text-field
                            label="Nome"
                            v-model="form.nome"
                            dense
                            outlined
                            hide-details
                        />
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-select
                            label="Conta"
                            v-model="form.conta_id"
                            :items="contas"
                            item-text="nome"
                            item-value="id"
                            dense
                            outlined
                            hide-details
                        />
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-select
                            label="Categoria"
                            v-model="form.categoria_id"
                            :items="itensCategoria"
                            item-text="nome"
                            item-value="id"
                            dense
                            outlined
                            hint="Só os lançamentos dessa categoria contam para a meta"
                            persistent-hint
                        />
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-text-field
                            label="Total previsto"
                            v-model.number="form.total"
                            type="number"
                            step="0.01"
                            min="0"
                            prefix="R$"
                            dense
                            outlined
                            hide-details
                        />
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-text-field
                            label="Início"
                            v-model="form.data_inicio"
                            type="date"
                            dense
                            outlined
                            hide-details
                        />
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-text-field
                            label="Fim"
                            v-model="form.data_fim"
                            type="date"
                            dense
                            outlined
                            hide-details
                        />
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-btn text color="warning" @click="$emit('close')">Cancelar</v-btn>
                <v-spacer/>
                <v-btn color="success" @click="salvar" :loading="loading">
                    <v-icon>mdi-content-save</v-icon>&nbsp;Salvar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'MetaForm',

    props: {
        visible: { type: Boolean, default: false },
        formData: { type: Object, default: () => ({}) },
        contas: { type: Array, default: () => [] },
        categorias: { type: Array, default: () => [] },
    },

    data: () => ({
        form: {},
        loading: false,
    }),

    computed: {
        itensCategoria() {
            return [
                { id: null, nome: 'Todas as categorias (conta inteira)' },
                ...this.categorias,
            ];
        },
    },

    watch: {
        formData(value) {
            this.form = value ? JSON.parse(JSON.stringify(value)) : {};
        },
    },

    methods: {
        salvar() {
            const required = ['nome', 'conta_id', 'total', 'data_inicio', 'data_fim'];
            for (const k of required) {
                if (this.form[k] === undefined || this.form[k] === null || this.form[k] === '') {
                    alert('Preencha todos os campos');
                    return;
                }
            }
            if (this.form.categoria_id === undefined) {
                alert('Selecione a categoria da meta');
                return;
            }
            if (this.form.data_fim < this.form.data_inicio) {
                alert('Data fim deve ser maior ou igual à data início');
                return;
            }

            const payload = {
                nome: this.form.nome,
                conta_id: this.form.conta_id,
                categoria_id: this.form.categoria_id,
                total: Number(this.form.total),
                data_inicio: this.form.data_inicio,
                data_fim: this.form.data_fim,
            };

            this.loading = true;
            const id = this.form.id;
            const req = id
                ? this.$http.put(`financeiro-interno/metas/${id}`, payload)
                : this.$http.post('financeiro-interno/metas', payload);

            req.then(() => this.$emit('onCadastro'))
                .catch(e => alert(e?.response?.data?.message || 'Erro ao salvar'))
                .finally(() => (this.loading = false));
        },
    },
};
</script>
